import React from 'react';
import Link from 'next/link';
import { SEO } from '@/components/SEO';

const Custom404: React.FC = () => {
  const breadcrumbs = [
    { position: 1, name: 'Home', item: '/' },
    { position: 2, name: '404', item: '/404' }
  ];

  return (
    <>
      <SEO 
        title="Page Not Found | Mobile Mechanic Services"
        description="The page you are looking for could not be found."
        canonicalUrl="/404"
        breadcrumbs={breadcrumbs}
      />
      <main className="container mx-auto px-4 py-16 text-center">
        <h1 className="text-4xl font-bold mb-6">Page Not Found</h1>
        <p className="text-gray-700 mb-8">
          The page you are looking for could not be found.
        </p>
        <Link 
          href="/"
          className="bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold text-lg hover:bg-blue-700 transition-colors inline-block"
        >
          Return Home
        </Link>
      </main>
    </>
  );
};

export default Custom404; 